import { } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../features/auth/hooks/useAuth'
import './AppHeader.css'

export default function AppHeader() {
  const { user, signOut, isLoading } = useAuth()
  const location = useLocation()

  const handleSignOut = async () => {
    try {
      await signOut()
    } catch (error) {
      // Error handling is managed by the auth context
      console.error('Sign out error:', error)
    }
  }

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="app-title">
            <Link to="/">Stash Dash</Link>
          </h1>
          <nav className="main-nav">
            <Link 
              to="/" 
              className={location.pathname === '/' ? 'nav-link active' : 'nav-link'}
            >
              Dashboard
            </Link>
            <Link 
              to="/trends" 
              className={location.pathname === '/trends' ? 'nav-link active' : 'nav-link'}
            >
              Trends
            </Link>
          </nav>
        </div>

        <div className="header-right">
          {user && (
            <div className="user-info">
              <span className="user-email">{user.email}</span>
              <button 
                onClick={handleSignOut}
                disabled={isLoading}
                className="sign-out-button"
                title="Sign Out"
              >
                {isLoading ? '...' : 'Sign Out'}
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}